import Logo from "../components/Logo";
import LoginForm from "../components/LoginForm";
import "../css/LandingPage.css";

export default function LoginPage() {
  return (
    <div className="standalone-login">
      <div className="standalone-login-panel">
        <Logo maxWidth="220px" marginBottom="1rem" />
        <h1>Login</h1>
        <LoginForm />
      </div>
    </div>
  );
}
